"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactI18next = require("react-i18next");

var _Grid = _interopRequireDefault(require("@material-ui/core/Grid"));

var _Button = _interopRequireDefault(require("@jobmatchme/ui/es/components/styleguide/Button"));

var _styleModule = _interopRequireDefault(require("./style.module.scss"));

var _jsxRuntime = require("react/jsx-runtime");

var translateNs = 'pc-matching:VerticalSelection:Actions';

var Actions = function Actions(_ref) {
  var actionType = _ref.actionType,
      abort = _ref.abort,
      confirm = _ref.confirm;

  var _useTranslation = (0, _reactI18next.useTranslation)(),
      t = _useTranslation.t;

  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Grid.default, {
    container: true,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Grid.default, {
      item: true,
      xs: 6,
      alignContent: "center",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.default, {
        texttransform: "none",
        className: _styleModule.default.button,
        onClick: abort,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
          children: t("".concat(translateNs, ".abort"))
        })
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Grid.default, {
      item: true,
      xs: 6,
      alignContent: "center",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.default, {
        color: "primary",
        variant: "contained",
        round: true,
        flat: true,
        texttransform: "none",
        className: _styleModule.default.button,
        onClick: confirm,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
          children: actionType ? t("".concat(translateNs, ".").concat(actionType)) : ''
        })
      })
    })]
  });
};

var _default = Actions;
exports.default = _default;